export interface TallyVendor {
  companyName: string;
  vendorName: string;
  vendorGST: string | null;
  chartOfAccount: string;
  voucherName: string;
  tdsRate: number;
  tdsThreshold: number;
  tdsResidual: number;
}

// Vendor Review Types - Using camelCase to match API response
export interface VendorMatch {
  vendorId: string;
  vendorName: string;
  vendorGST?: string;
  companyId?: string;
  companyName?: string;
  similarityScore: number;
}

export interface VendorReviewRequest {
  reviewId: string;
  extractedVendorName: string;
  vendorGST?: string;
  companyId?: string;
  fileName?: string;
  orchestrationInstanceId?: string;
  batchId?: string;
  currentPage?: number;
  totalItems?: number;
  pageSize?: number;
}

export enum VendorReviewDecisionType {
  MapExisting = 'MapExisting',
  CreateNew = 'CreateNew',
}

export enum VendorReviewStatus {
  Pending = 'Pending',
  Completed = 'Completed',
}

export interface VendorReviewDecision {
  ReviewId: string;
  Decision: VendorReviewDecisionType;
  SelectedVendorId?: string;
  NewVendorName?: string;
}

// Batch vendor review request for receiving multiple vendors in a single Pusher event
export interface BatchVendorReviewRequest {
  BatchId: string;
  OrchestrationInstanceId: string;
  VendorReviews: VendorReviewRequest[];
}

// Vendor review with matching vendors included (from API response)
export interface VendorReviewWithMatches extends VendorReviewRequest {
  matchingVendors: VendorMatch[];
}

export enum TallyLedgerGroups {
  purchaseAccount = 'Purchase Accounts',
  salesAccount = 'Sales Accounts',
  indirectExpesesAccount = 'Indirect Expenses',
  indirectIncomesAccount = 'Indirect Incomes',
  directExpensesAccount = 'Direct Expenses',
  directIncomesAccount = 'Direct Incomes',
}

export enum TallyVendorLedgerGroups {
  sundryCreditors = 'Sundry Creditors',
  sundryDebtors = 'Sundry Debtors',
}

export enum TallyVouchersTypes {
  sales = 'Sales',
  purchase = 'Purchase',
  expense = 'Expense',
  abnormal = 'Abnormal',
  journal = 'Journal',
  debitNote = 'Debit Note',
  creditNote = 'Credit Note',
}

export enum TallyChartOfAccountTypes {
  sales = 'Sales',
  purchase = 'Purchase',
  abnormal = 'Abnormal',
}

export const Fetch_Data_For_Vouchers: TallyVouchersTypes[] = [
  TallyVouchersTypes.purchase,
  TallyVouchersTypes.sales,
  TallyVouchersTypes.expense,
  TallyVouchersTypes.journal,
];
